import { Component, EventEmitter, Input, NgZone, OnInit, Output, SimpleChanges } from '@angular/core';
import { StorageService } from 'src/app/Services/storage.service';
declare var google: any;
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';

@Component({
  selector: 'app-geofence-location',
  templateUrl: './geofence-location.component.html',
  styleUrls: ['./geofence-location.component.css']
})

export class GeofenceLocationComponent implements OnInit {

  @Input() mapHeight: string;
  @Output() result: any = new EventEmitter();
  @Input () isMultipleGeo:boolean;
  @Input() public set geofenceRadius(val: number) {
    this.circleRadius=val;
    this.triggerCircleDraw();
  }
  @Input() public set markedlocations(data:any){
    setTimeout(()=>{
      this.geoLocations=data;
      for(let i=0;i<this.geoLocations.length;i++){
        let loc=new google.maps.LatLng(+this.geoLocations[i]['location']['lat'], +this.geoLocations[i]['location']['lng']);
        this.placeMarker(loc,this.geoLocations[i]['radius'],this.geoLocations[i]?.editTrue);
      }
    },1000)
  };

  public selectedMap:string='osrm';
  public googleMapObj:any;
  public markersArray:any=[];
  public locationData={};
  //google search
  public mapSearchDataLists = [];
  public mapSearchChangeObserver: any;
  
  //geofence
  public pickupRadiusCircle:any;
  public circleRadius:number;
  public isLoctionMarked:boolean=false;
  public geoLocations:any=[];
  constructor(
    public api: ApiService,
    public storage: StorageService,
    public ngZone:NgZone,
    ) 
    { 
      let user = this.storage.get('userInfo');
      if(user && user.map){
        this.selectedMap = user.map;
      }
    }

  ngOnInit(): void {
    this.loadMap();
  }
  loadMap(){
    let geofenceMap=document.getElementById('geofenceMap');
    if(this.selectedMap=='google' && geofenceMap!=null){
      setTimeout(()=>{
        const mapOptions = {
          scrollwheel: true,
          zoom: 10,
          maxZoom: 17,
          center: new google.maps.LatLng(13.1031,80.1794),
          fullscreenControl: false,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP,
          },
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_CENTER,
          },
          streetViewControl: false,
        };
        this.googleMapObj = new google.maps.Map(document.getElementById('geofenceMap'), mapOptions);
        google.maps.event.addListener(this.googleMapObj,'click', (e) => {
          if(this.markersArray.length>0){
            this.clearOverlays();
          }
          this.placeMarker(e.latLng,this.circleRadius,'');
        });
      },100)
    }
  }
  placeMarker(location,radius,condition) {
    let latLng={};
    if(location.lat() && location.lng()){
      latLng=new google.maps.LatLng(+location.lat(), +location.lng())
    }else {
      latLng={};
    }
    this.markersArray=[];
    let image = {
      url : "https://maps.google.com/mapfiles/ms/icons/purple-dot.png"
    }
    let marker = new google.maps.Marker({
        position: location, 
        map: this.googleMapObj,
        draggable: true,
        icon:image
    });
    this.markersArray.push(marker)
    let loc={
      lat: +location.lat(),
      lng: +location.lng()
    }
    if(marker){
      this.isLoctionMarked=true;
    }
    this.drawCircleGgl(loc,radius);
    marker.addListener('dragend', (e)=> this.dragToFindAddress(location,e));
    marker.addListener('click', (e)=> {
      let loc= new google.maps.LatLng(+e.latLng.lat(),+e.latLng.lng());
      this.googleMapObj.panTo(loc);
      this.googleMapObj.setZoom(15);
    })
    this.googleMapObj.panTo(latLng);//for focusing marked location
    this.googleMapObj.setZoom(15);
    let obj={
      "params":{
        "latlng":`${+location.lat().toFixed(5)},${+location.lng().toFixed(5)}`
      }
    }
    this.api.transportManagerGoogleMapGeocoder(obj).then((res: any) => {
      if (res.status == 'success') {
        let response=JSON.parse(res.data);
        this.locationData['lat'] = +location.lat().toFixed(5);
        this.locationData['lng'] = +location.lng().toFixed(5);
        this.locationData['name'] = response['results'][0]['formatted_address'];
        this.locationData['condition']=condition; 
        this.result.emit(this.locationData);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  clearOverlays() {
    for (var i = 0; i < this.markersArray.length; i++ ) {
     this.markersArray[i].setMap(null);
    }
  }
  dragToFindAddress(loc,e) {
    let obj={
      "params":{
        "latlng":`${+e.latLng.lat().toFixed(5)},${+e.latLng.lng().toFixed(5)}`
      }
    }
    let location={
      lat: +e.latLng.lat(),
      lng: +e.latLng.lng()
    }
    this.drawCircleGgl(location,this.circleRadius);
    this.api.transportManagerGoogleMapGeocoder(obj).then((res: any) => {
      if (res.status == 'success') {
        let response=JSON.parse(res.data);
        this.locationData['lat'] = +e.latLng.lat().toFixed(5);
        this.locationData['lng'] = +e.latLng.lng().toFixed(5);
        this.locationData['name'] = response['results'][0]['formatted_address'];
        this.result.emit(this.locationData);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  mapSearchFind(location) {
    location = location.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.mapSearchChangeObserver) {
    new Observable(observer => {
        this.mapSearchChangeObserver = observer;
    }).pipe(debounceTime(1000)) // wait 1000ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
            // your code here
            if(term==''){
                this.mapSearchDataLists = [];
            }
            else{
              const options = {
                  fields: ["formatted_address", "geometry", "name"],
                  strictBounds: false,
                  types: ["establishment"],
              };
              
              const searchInput: any = document.getElementById('mapSearchBox');// as HTMLInputElement;

              const autocomplete = new google.maps.places.Autocomplete(searchInput, options);
              autocomplete.addListener('place_changed', () => {
                  this.ngZone.run(() => {
                      const getResults = autocomplete.getPlace();
                      try{
                          let name = getResults.formatted_address ? getResults.formatted_address : ''; 
                          let lat = getResults.geometry && getResults.geometry.location && getResults.geometry.location.lat() ? getResults.geometry.location.lat() : '';
                          let lng = getResults.geometry && getResults.geometry.location && getResults.geometry.location.lng() ? getResults.geometry.location.lng() : '';

                          if(lat != '' && lng !=''){
                            if(this.selectedMap == 'google'){
                              this.googleMapObj.setZoom(15);
                              
                              if(this.markersArray.length>0){
                                this.clearOverlays();
                              }
                              this.placeMarker(getResults.geometry.location,this.circleRadius,'');
                            }
                          }
                      }catch(err){
                          console.log('location bind error',err);
                      }

                  });
              });             
            }
        });
    }

    this.mapSearchChangeObserver.next(location);

  }
  triggerCircleDraw(){
    if(this.isLoctionMarked && this.locationData['lat'] && this.locationData['lng']){
      let location={
        lat : this.locationData['lat'],
        lng : this.locationData['lng']
      }
      this.drawCircleGgl(location,this.circleRadius);
    }
  }
  
  drawCircleGgl(loc,radius){
    if(!this.isMultipleGeo){
      if(this.pickupRadiusCircle){
        this.pickupRadiusCircle.setMap(null);
      }
    }
    this.pickupRadiusCircle = new google.maps.Circle({
        strokeColor: "rgb(98,100,167)",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "rgb(154,155,194)",
        fillOpacity: 0.35,
        map: this.googleMapObj,
        center: loc,
        radius: (radius>0&&radius<=25) ? radius * 1000 : 0,
      });
  }
}
